var _defs, _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew264({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.11,15.1a10.09,10.09,0,0,0,0-14.2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 3.22,
    cy: 8,
    r: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.65,3,4.42,7.73a1.17,1.17,0,0,1,0,.27,1.17,1.17,0,0,1,0,.27L12.65,13A10,10,0,0,0,14,8,10,10,0,0,0,12.65,3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew264);
export default __webpack_public_path__ + "static/media/Symbolpack_New_264.96c51b748c85f031f70a2fa803f20601.svg";
export { ForwardRef as ReactComponent };